module.exports = __webpack_public_path__ + "img/voyage.c7e2fd21.jpg";